import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function PreferencesSkeleton({ isDarkMode }) {
    const cardCls = `rounded-3xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const panelCls = `rounded-xl p-6 ${isDarkMode ? "bg-slate-700/50" : "bg-slate-50"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`max-w-4xl mx-auto space-y-8 p-6 ${isDarkMode ? "bg-surface" : ""}`}>
                {/* Page header */}
                <header>
                    <Skeleton width={280} height={30} className="mb-2" />
                    <Skeleton width={340} height={16} />
                </header>

                <div className={`${cardCls} p-8 space-y-10`}>
                    {/* Current Information: label/value grid + avatar */}
                    <section>
                        <div className="flex items-center gap-3 mb-6">
                            <Skeleton width={24} height={24} borderRadius={6} />
                            <Skeleton width={200} height={22} />
                        </div>
                        <div className={`${panelCls} mb-6`}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i}>
                                        <Skeleton width={100} height={12} className="mb-2" />
                                        <Skeleton width="70%" height={18} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <Skeleton circle width={80} height={80} />
                            <div className="space-y-2">
                                <Skeleton width={140} height={36} borderRadius={8} />
                                <Skeleton width={100} height={12} />
                            </div>
                        </div>
                    </section>

                    {/* Two form sections: heading + input fields */}
                    {Array.from({ length: 2 }).map((_, s) => (
                        <section key={s}>
                            <div className="flex items-center gap-3 mb-6">
                                <Skeleton width={24} height={24} borderRadius={6} />
                                <Skeleton width={180} height={22} />
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i}>
                                        <Skeleton width={90} height={12} className="mb-2" />
                                        <Skeleton height={42} borderRadius={8} />
                                    </div>
                                ))}
                            </div>
                        </section>
                    ))}

                    {/* Save button row */}
                    <div className="flex justify-end">
                        <Skeleton width={130} height={44} borderRadius={10} />
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
